import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, TemplateRef, ViewContainerRef } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserIdleService } from 'angular-user-idle';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { AccessMenuService } from '@fuse/services/access-menu.service';
import { UtilService } from 'app/util/util.service';
import { Constants } from 'app/util/constant.model';
import { Router } from '@angular/router';
import { navigation } from 'app/navigation/navigation';
import { locale as navigationEnglish } from 'app/navigation/i18n/en';
import { locale as navigationTurkish } from 'app/navigation/i18n/es';
import * as jwt_decode from 'jwt-decode';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PagMantenimientoComponent } from './pag-mantenimiento/pag-mantenimiento.component';
import { MatPaginator, MatSnackBar, MatSort, MAT_DATE_LOCALE, MAT_DATE_FORMATS, DateAdapter } from '@angular/material';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { disableCursor } from '@fullcalendar/core/util/misc';
import { ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { AnyFn } from '@ngrx/store/src/selector';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

    confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;

    fuseConfig: any;
    navigation: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    @ViewChild('dialogVacaciones') dialogVacaciones!: TemplateRef<any>;
    vacacionInfo = { message: '', inicio: '', fin: '', modalidad: '', horaInicio: '', horaFin: '' };

    /**
     * Constructor
     *
     * @param {DOCUMENT} document
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {FuseSplashScreenService} _fuseSplashScreenService
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * @param {Platform} _platform
     * @param {TranslateService} _translateService
     * @param {AccessMenuService} _accessMenuService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _accessMenuService: AccessMenuService,
        private _utilService: UtilService,
        private _translateService: TranslateService,
        private _platform: Platform,
        private _router: Router,
        // private _userIdle: UserIdleService,
        private _ngxService: NgxUiLoaderService,
        public dialog: MatDialog,
        private cd: ChangeDetectorRef,
        private router: Router,
        private route: ActivatedRoute,
    ) {

        // Get default navigation
        this.navigation = navigation;

        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);

        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');

        // Add languages
        this._translateService.addLangs(['en', 'tr']);

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        this._fuseTranslationLoaderService.loadTranslations(navigationEnglish, navigationTurkish);

        // Use a language
        this._translateService.use('en');

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix Start
         * ----------------------------------------------------------------------------------------------------
         */

        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         **/

        // Set the default language to 'en' and then back to 'tr'.
        // '.use' cannot be used here as ngxTranslate won't switch to a language that's already
        // been selected and there is no way to force it, so we overcome the issue by switching
        // the default language back and forth.
        /**
         setTimeout(() => {
            this._translateService.setDefaultLang('en');
            this._translateService.setDefaultLang('tr');
         });
         */

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix End
         * ----------------------------------------------------------------------------------------------------
         */

        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
            window.localStorage.setItem("_m", "1");
        } else {
            window.localStorage.removeItem("_m");
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        // Escucha si el Login tradicional (u otro componente) pide abrir el diálogo
        this._accessMenuService.mostrarModalAccesoRestringido$.subscribe((info) => {
            this.vacacionInfo = info; // Asigna los datos recibidos al objeto local que usa el HTML
            
            this.dialog.open(this.dialogVacaciones, {
            width: '420px',
            disableClose: true
            });
        });

        this.route.queryParams.subscribe(params => {
            if (params['redirect']) {
                this.router.navigateByUrl(params['redirect']);
            } else {
                this.router.navigate(['/apps/dashboards/resumen/']);
            }
        });


        // Verifica si la URL tiene una ruta específica
        const storedRoute = sessionStorage.getItem('redirectRoute');

        if (storedRoute) {
            sessionStorage.removeItem('redirectRoute'); // Limpiar para que no se use varias veces
            this._router.navigateByUrl(storedRoute);
        }

        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.fuseConfig = config;

                // Boxed
                if (this.fuseConfig.layout.width === 'boxed') {
                    this.document.body.classList.add('boxed');
                }
                else {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for (let i = 0; i < this.document.body.classList.length; i++) {
                    const className = this.document.body.classList[i];

                    if (className.startsWith('theme-')) {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);
            });

        if (!window.localStorage.getItem('token')) {
            this.getParamsObjectFromHash();
            // console.log(this.getParamsObjectFromHash());
            // if (this.getParamsObjectFromHash() == null) {
            //     console.log("Ingreso a login");
            //     this._router.navigate(['login']);
            //     return;
            // } else {
            //     console.log(this.getParamsObjectFromHash()["id_token"]);
            //     var decoded = jwt_decode(this.getParamsObjectFromHash()["id_token"]);
            //     console.log(decoded);
            //     this._accessMenuService.generateToken(decoded.email).subscribe((response: any) => {
            //         console.log(response);
            //         if (response == 200) {

            //             window.localStorage.setItem('data', JSON.stringify(
            //                 {
            //                     nombres: decoded.given_name,
            //                     apellidos: decoded.family_name,
            //                     email_verified: decoded.email_verified,
            //                     picture: decoded.picture
            //                 }));

            //             this._router.navigate(['/apps/dashboards/resumen/']);

            //         } else {
            //             alert("Correo no autorizado");
            //         }
            //     });
            // }
        }

        // //Start watching for user inactivity.
        // this._userIdle.startWatching();

        // // Start watching when user idle is starting.
        // // this.userIdle.onTimerStart();
        // this._userIdle.onTimerStart().subscribe(count => { });

        // // Start watch when time is up.
        // this._userIdle.onTimeout().subscribe(() => this._router.navigate(['login']));

        // setTimeout(() => {
        //     this.abrirModal();
        // }, 1000);

    }

    // abrirModal(item: any) {
    //     const dialogRef = this.dialog.open(PagMantenimientoComponent, { disableClose:true } {

    //     });
    //   }


    //Edwin
    abrirModal() {

        this._utilService.getLisDetalleControlSistema(Constants.val_const_tipo_control_sistema_mantenimiento, Constants.const_vacio, Constants.const_vacio, Constants.const_vacio, Constants.const_vacio)
            .subscribe(async data => {

                if (data["Status"] == "200" && data["Result"]) {
                    this.dialog.open(PagMantenimientoComponent, { disableClose: true })
                }
            }, error => {
                console.log(<any>error);
            })
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }


    // getParamsObjectFromHash() {

    //     const hash = window.location.hash ? window.location.hash.split('#') : [];

    //     let toBeReturned = {};

    //     if (hash.length && hash[1].split('&').length) {
    //         toBeReturned = hash[1].split('&').reduce((acc, x) => {
    //             const hello = x.split('=');
    //             if (hello.length === 2) acc[hello[0]] = hello[1];
    //             return acc;
    //         }, {});
    //     }

    //     if (Object.keys(toBeReturned).length) {
    //         this._ngxService.start();
    //         this._ngxService.startBackground('do-background-things');
    //         this._ngxService.stopBackground('do-background-things');
    //         this._ngxService.startLoader('loader-01');
    //         // console.log(toBeReturned["id_token"]);
    //         var decoded = jwt_decode(toBeReturned["id_token"]);
    //         // console.log(decoded);
    //         this._accessMenuService.generateToken(decoded.email).subscribe(data => {

    //             if (data) {

    //                 // var decoded1 = jwt_decode(data);

    //                 // this._utilService.getLisFilesForName(JSON.parse(decoded1["sub"])["documentoidentidad"]).subscribe(data1 => {

    //                 //     console.log(data1);

    //                 //     // window.localStorage.setItem('data', JSON.stringify(
    //                 //     //     {
    //                 //     //         nombres: decoded.given_name,
    //                 //     //         apellidos: decoded.family_name,
    //                 //     //         email_verified: decoded.email_verified,
    //                 //     //         // picture: (data1["data"] && data1["data"][0] && data1["data"][0]["id"] ? "https://drive.google.com/uc?export=view&id=" + data1["data"][0]["id"] : "assets/images/personal/personal.png")
    //                 //     //     }));
    //                 //     // this._ngxService.stop();

    //                 //     this._router.navigate(['/apps/dashboards/resumen/']);

    //                 // }, error => {

    //                 //     console.log(<any>error);

    //                 //     // window.localStorage.setItem('data', JSON.stringify(
    //                 //     //     {
    //                 //     //         nombres: decoded.given_name,
    //                 //     //         apellidos: decoded.family_name,
    //                 //     //         email_verified: decoded.email_verified,
    //                 //     //         // picture: "assets/images/personal/personal.png"
    //                 //     //     }));
    //                 //     // this._ngxService.stop();

    //                 //     // this._router.navigate(['/apps/dashboards/resumen/']);
    //                 // })


    //                 window.localStorage.setItem('data', JSON.stringify(
    //                     {
    //                         nombres: decoded.given_name,
    //                         apellidos: decoded.family_name,
    //                         email_verified: decoded.email_verified,
    //                         picture: decoded.picture
    //                     }));
    //                 this._ngxService.stop();
    //                 //this._router.navigate(['login']);
    //                 this._router.navigate(['/apps/dashboards/resumen/']);

    //             } else {
    //                 alert("Correo no autorizado");
    //                 this._ngxService.stop();
    //             }
    //         });
    //     } else {
    //         // console.log("Ingreso a login");
    //         this._router.navigate(['login']);
    //         return;
    //     }

    //     // return Object.keys(toBeReturned).length ? toBeReturned : null;
    // }

    // getParamsObjectFromHash() {
    //     const hash = window.location.hash ? window.location.hash.split('#') : [];
    //     let toBeReturned = {};

    //     if (hash.length && hash[1].split('&').length) {
    //         toBeReturned = hash[1].split('&').reduce((acc, x) => {
    //             const hello = x.split('=');
    //             if (hello.length === 2) acc[hello[0]] = hello[1];
    //             return acc;
    //         }, {});
    //     }

    //     if (Object.keys(toBeReturned).length) {
    //         this._ngxService.start();
    //         this._ngxService.startBackground('do-background-things');
    //         this._ngxService.stopBackground('do-background-things');
    //         this._ngxService.startLoader('loader-01');

    //         var decoded = jwt_decode(toBeReturned["id_token"]);

    //         // Verificar si el correo tiene el dominio deseado
    //         if (decoded.email.endsWith('@vivienda.gob.pe')) {
    //             this._accessMenuService.generateToken(decoded.email).subscribe(data => {
    //                 if (data) {
    //                     const horacerrarsesion = new Date().getTime(); // Hora en milisegundos
    //                     window.localStorage.setItem('data', JSON.stringify({
    //                         nombres: decoded.given_name,
    //                         apellidos: decoded.family_name,
    //                         email_verified: decoded.email_verified,
    //                         picture: decoded.picture,
    //                         loginTime: horacerrarsesion  // tiempo de inicio de sesion
    //                     }));
    //                     this._ngxService.stop();
    //                     this._router.navigate(['/apps/dashboards/resumen/']);
    //                 } else {
    //                     alert("Correo no autorizado");
    //                     this._ngxService.stop();
    //                 }
    //             });
    //         } else {
    //             alert("Correo no autorizado");
    //             this._ngxService.stop();
    //             this._router.navigate(['login']);
    //         }
    //     } else {
    //         this._router.navigate(['login']);
    //         return;
    //     }
    // }

    getParamsObjectFromHash() {
        const hash = window.location.hash ? window.location.hash.split('#') : [];
        let toBeReturned = {};

        if (hash.length && hash[1].split('&').length) {
            toBeReturned = hash[1].split('&').reduce((acc, x) => {
                const hello = x.split('=');
                if (hello.length === 2) acc[hello[0]] = hello[1];
                return acc;
            }, {});
        }

        if (Object.keys(toBeReturned).length) {
            this._ngxService.start();
            this._ngxService.startBackground('do-background-things');
            this._ngxService.stopBackground('do-background-things');
            this._ngxService.startLoader('loader-01');

            const decodedGoogle = jwt_decode(toBeReturned["id_token"]);

            // Verificar si el correo tiene el dominio deseado
            if (decodedGoogle.email.endsWith('@vivienda.gob.pe')) {
                
                this._accessMenuService.generateToken(decodedGoogle.email).subscribe(response => {
                console.log("RESPUESTA SERVIDOR:", response);

                if (response && response["Status"] == 200) {
                    // --- FLUJO LOGIN  ---
                    const token = response["Token"];
                    const horacerrarsesion = new Date().getTime();
                    const decodedInterno = jwt_decode(token); 
                    const userData = JSON.parse(decodedInterno["sub"]);

                    window.localStorage.setItem('data', JSON.stringify({
                        nombres: decodedGoogle.given_name ? decodedGoogle.given_name : userData.nombres,
                        apellidos: decodedGoogle.family_name ? decodedGoogle.family_name : (userData.apellidopaterno + " " + userData.apellidomaterno),
                        email_verified: decodedGoogle.email_verified,
                        picture: decodedGoogle.picture ? decodedGoogle.picture : 'assets/images/personal/personal.png',
                        dni: userData.documentoidentidad, 
                        capi: userData.capacitacionactiva, 
                        loginTime: horacerrarsesion,
                    }));

                    this._ngxService.stop();

                    const redirectUrl = toBeReturned["redirect"] ? decodeURIComponent(toBeReturned["redirect"]) : null;
                    if (redirectUrl) {
                        this._router.navigateByUrl(redirectUrl);
                    } else {
                        this._router.navigate(['/apps/dashboards/resumen/']);
                    }

                } else if (response && response["Status"] == "405") {
                    // --- FLUJO DETECCIÓN DE VACACIONES ---
                    this._ngxService.stop();
                    
                    const datos = (response && response["Value"] && response["Value"][0]) 
                                ? response["Value"][0] 
                                : [];

                    this.vacacionInfo = {
                        message: response["Message"] || 'Existe registros en el sistema',
                        inicio: datos[2] || 'No especificada',      
                        fin: datos[3] || 'No especificada',         
                        modalidad: datos[23] ? datos[23] : datos[6] || 'No especificada',
                        horaInicio: datos[13],
                        horaFin: datos[14]    
                    };

                    this.dialog.open(this.dialogVacaciones, {
                        width: '420px',
                        disableClose: true
                    });
                } else {
                    this._ngxService.stop();
                    console.log("Error de autenticación alternativo", response);
                    alert("Correo no autorizado o credenciales inválidas.");
                }
            });
            } else {
                alert("Correo no autorizado**");
                this._ngxService.stop();
                this._router.navigate(['login']);
            }
        } else {
            this._router.navigate(['login']);
            return;
        }
    }



    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    // stop() {
    //     this._userIdle.stopTimer();
    // }

    // stopWatching() {
    //     this._userIdle.stopWatching();
    // }

    // startWatching() {
    //     this._userIdle.startWatching();
    // }

    // restart() {
    //     this._userIdle.resetTimer();
    // }
}
